<template>
  <div
    class="hero"
    :class="[layout, { h: $route.name != 'home' }]"
    :style="{ height }"
  >
    <div class="text container">
      <h1
        class="text-white m-0 text-center text-lg-left mb-5 mb-lg-0"
        data-aos="fade-down"
        data-aos-duration="1000"
        v-html="title"
        :style="{ textAlign }"
      ></h1>
    </div>

    <div class="container">
      <div
        class="
          search
          d-flex
          align-items-center
          justify-content-center justify-content-lg-start
        "
        v-if="search"
      >
        <input
          type="text"
          placeholder="Pesquisar Oportunidades"
          v-model="searchText"
          @keypress.enter="
            searchText ? $router.push(`/vagas?busca=${searchText}`) : ''
          "
        />
        <button
          @click="searchText ? $router.push(`/vagas?busca=${searchText}`) : ''"
        >
          <img src="@/assets/images/search.svg" alt="" />
        </button>
      </div>
    </div>

    <div class="media-content">
      <img
        :src="require(`@/assets/images/confidence/${image}`)"
        v-if="image"
        class="rounded shadow-lg"
      />

      <video
        autoplay
        loop=""
        playsinline=""
        muted=""
        class="bg-dark"
        v-if="video"
      >
        <source :src="require(`@/assets/videos/${video}`)" />
        !
      </video>
    </div>
  </div>
</template>

<script>
import SearchJob from "@/components/jobs/SearchJob.vue";

export default {
  name: "Hero",
  data() {
    return {
      searchText: "",
    };
  },
  props: {
    title: String,
    video: String,
    search: Boolean,
    image: String,
    layout: String,
    height: null,
    textAlign: String,
  },

  components: {
    SearchJob,
  },
};
</script>

<style lang="scss">
.hero {
  width: 100vw;
  height: 100vh;
  min-height: 400px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 9;
  margin-bottom: 20px;

  @include media-breakpoint-up(lg) {
    justify-content: flex-end;
  }
  @include media-breakpoint-down(sm) {
    &.h {
      height: 40vh !important;
      min-height: 20% !important;
    }
  }
  .search {
    width: 100%;
    @include media-breakpoint-up(lg) {
      margin-top: 5rem;
      margin-bottom: -1.7rem;
    }
    input {
      background-color: #fff;
      border: 1px solid #999999;
      border-radius: 8px;
      height: 50px;
      width: 100%;
      max-width: 553px;
      order: 2;
      padding-left: 3.5rem;
      z-index: 1;
      &::placeholder {
        color: rgba(#5d646c, 0.5);
        font-weight: 400;
      }
    }
    button {
      border: none;
      background-color: transparent;
      order: 1;
      position: relative;
      z-index: 9;
      margin-right: -2.5rem;
      img {
        width: 16px;
        @include media-breakpoint-down(sm) {
          margin-top: -2px;
        }
      }
    }
  }

  &:after {
    content: "";
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: -1;
    background: transparent
      linear-gradient(
        69deg,
        var(--unnamed-color-da292f) 0%,
        var(--unnamed-color-212644) 100%
      )
      0% 0% no-repeat padding-box;
   /*  background: transparent linear-gradient(69deg, #da292f 0%, #212644 100%) 0%
      0% no-repeat padding-box; */
    mix-blend-mode: soft-light;
    opacity: 0.8;
  }

  &.md {
    height: 40vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  &.half {
    height: 50vh;
    min-height: auto;
    overflow: unset;

    & > .media-content {
      width: 100vw;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  & > .text {
    z-index: 1;
    .input-group {
      .form-control,
      .btn {
        height: calc(4rem + 2px);
        display: flex;

        &::placeholder {
          opacity: 0.5;
        }
      }
    }

    h1 {
      font-size: 3.7rem;
      font-weight: bold;
      text-align: left;
      line-height: calc(3.7rem * 1.3);
      strong {
        font-weight: 600;
      }

      @include media-breakpoint-down(md) {
        font-size: 2rem;
        line-height: calc(2rem * 1.3);
      }
    }
  }

  & > .media-content,
  & > .media-content > img,
  & > .media-content > video {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: middle;
    z-index: -1;
    overflow: hidden;
  }

  *::-webkit-media-controls-panel {
    display: none !important;
    -webkit-appearance: none;
  }

  *::--webkit-media-controls-play-button {
    display: none !important;
    -webkit-appearance: none;
  }

  *::-webkit-media-controls-start-playback-button {
    display: none !important;
    -webkit-appearance: none;
  }
}
</style>
